import {flightStates} from '../../flights/flights-routes';
import actionTripMessages from './../config/actionTripMessages.constant';

export default function TripBookingService(
    l10nService,
    toleranceHelper,
    tripOptionsService,
    flightsUtils,
    tripFactory,
) {
    'ngInject';

    Object.assign(this, {
        renderSuccessMessage,
        renderFailedPaymentModal,
        renderOtherFailedCases,
        renderToleranceFail,
        isThereProblemWithPayment,
        isBookingSucceeded,
        isTripFailedWithTolerance,
    });

    function isTripFailedWithTolerance(response) {
        return toleranceHelper.tripFailedWithTolerance(response);
    }

    function renderSuccessMessage(response, tripId, tripDetails) { // eslint-disable-line
        const modal = {
            redirectTo: flightStates.ROUNDTRIP,
        };
        const title = tripDetails.IsOfflineTrip
            ? l10nService.localize('Pending confirmation')
            : l10nService.localize('Book status');

        if (response.IsFullyBooked || response.IsSentForConfirmation) {
            modal.title = title;
            modal.body = _.template(l10nService.localize(actionTripMessages.Booking.Booked))({id: tripId});
            if (toleranceHelper.tripPassedWithTolerance(response)) {
                modal.body += ' ' + l10nService.localize(actionTripMessages.Booking.TolerancePassed);
            }
            if (tripDetails.IsOfflineTrip) {
                modal.body = l10nService.localize(actionTripMessages.Booking.OfflineBooked);
            }
        }

        if (response.IsSentForApproval) {
            modal.title = title;

            const messageOnline = response.HasAutoHoldItems
                ? l10nService.localize(actionTripMessages.Booking.IsSentForApproval.SuccessWithHolding)
                : l10nService.localize(actionTripMessages.Booking.IsSentForApproval.Success);
            const messageOffline = l10nService.localize(actionTripMessages.Booking.OfflineBooked);

            const modalText = tripDetails.IsOfflineTrip
                ? messageOffline
                : messageOnline;

            modal.body = _.template(modalText)({id: tripId});
        }
        return modal;
    }

    function renderFailedPaymentModal(response) { // eslint-disable-line
        const modal = {
            title: l10nService.localize('Book status'),
            redirectTo: false,
        };

        // TODO: Make mapping object instead of switch..case statement
        switch (response.PaymentStatus) {
            case tripOptionsService.PAYMENT_STATUS.Failure:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.Failure);
                break;
            case tripOptionsService.PAYMENT_STATUS.FailureTryAgain:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.FailureTryAgain);
                break;
            case tripOptionsService.PAYMENT_STATUS.FailureOnlineHelpdesk:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.FailureOnlineHelpdesk);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidCardNumber:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidCardNumber);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidCardType:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidCardType);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidCardDetails:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidCardDetails);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidMinimumAmount:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidMinimumAmount);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidMaximumAmount:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidMaximumAmount);
                break;
            case tripOptionsService.PAYMENT_STATUS.Invalid3DSecureEnrolled:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.Invalid3DSecureEnrolled);
                break;
            case tripOptionsService.PAYMENT_STATUS.Invalid3DSecureSupport:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.Invalid3DSecureSupport);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidVisaPassword:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidVisaPassword);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidOnlineDisabled:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidOnlineDisabled);
                break;
            case tripOptionsService.PAYMENT_STATUS.InvalidOnlineRestriction:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.InvalidOnlineRestriction);
                break;
            default:
                modal.body = l10nService.localize(actionTripMessages.Booking.Adflex.Failure);
                break;
        }

        if (toleranceHelper.tripPassedWithTolerance(response)) {
            modal.body += ' ' + l10nService.localize(actionTripMessages.Booking.TolerancePassedButFailedItemsPresent);
        }
        return modal;
    }

    function renderOtherFailedCases(response, tripId, tripDetails, redirectTo) { // eslint-disable-line
        const modal = {redirectTo: flightStates.ROUNDTRIP};

        const bookingResponses = response.BookingResponses || [];
        const status = tripOptionsService.BOOKING_STATUS;
        const duplicateFlights = flightsDuplicationChecker(bookingResponses);
        const duplicateHotels = hotelsDuplicationChecker(bookingResponses);
        const amadeusFlights = flightsUtils.findAmadeusFlights(tripDetails);

        const failedSeats = response.AmadeusBookSeatResponse
            && response.AmadeusBookSeatResponse.length
            && response.AmadeusBookSeatResponse.filter(({IsBooked}) => !IsBooked)
            || [];

        switch (true) {
            case !!response.CanNoLongerBook :
                modal.title = l10nService.localize('Book status');
                modal.body = l10nService.localize(actionTripMessages.Booking.CanNoLongerBook);
                modal.redirectTo = {
                    url: 'main.trip.details',
                    params: {id: tripId},
                };
                break;
            //2. FAIL: All items are still available and approval is required
            case !!_.some(bookingResponses, {BookingStatus: status.Unconfirmed}) :
                modal.title = l10nService.localize('Book status');
                modal.body = l10nService.localize(actionTripMessages.Booking.Unconfirmed.part1) + l10nService.localize(actionTripMessages.Booking.Unconfirmed.part2);
                modal.items = tripFactory.findItems(status.Unconfirmed, response, tripDetails);
                break;
            //4. FAIL: Technical issue - no items can be booked due to technical fail
            case !!issuesChecker(bookingResponses, status.Failed) :
                modal.title = l10nService.localize('Technical issue');
                modal.body = l10nService.localize(actionTripMessages.Booking.AllFailed);
                break;
            case !!(failedSeats && failedSeats.length):
                modal.title = l10nService.localize('Technical issue');
                modal.body = l10nService.localize(actionTripMessages.Booking.Failed.part1) + l10nService.localize(actionTripMessages.Booking.Failed.part2);
                modal.items = {Seats: failedSeats};
                break;
            //5. FAIL: Technical issue - Some items cannot be booked due to technical fail
            case !!_.some(bookingResponses, {BookingStatus: status.Failed}) :
                modal.title = l10nService.localize('Technical issue');
                modal.body = l10nService.localize(actionTripMessages.Booking.Failed.part1) + l10nService.localize(actionTripMessages.Booking.Failed.part2);
                modal.items = tripFactory.findItems(status.Failed, response, tripDetails);
                break;
            //6. FAIL: Availability issue - All items cannot be booked due to no longer being available
            case !!issuesChecker(bookingResponses, status.NoLongerAvailable) :
                modal.title = l10nService.localize('Availability issue');
                modal.body = l10nService.localize(actionTripMessages.Booking.AllNoLongerAvailable);
                break;
            //7. FAIL: Availability issues – Some items cannot be booked due to no longer being available
            case !!_.some(bookingResponses, {BookingStatus: status.NoLongerAvailable}):
                modal.title = l10nService.localize('Availability issue');
                modal.body = l10nService.localize(actionTripMessages.Booking.NoLongerAvailable.part1) + l10nService.localize(actionTripMessages.Booking.NoLongerAvailable.part2);
                modal.items = tripFactory.findItems(status.NoLongerAvailable, response, tripDetails);
                break;
            case !!duplicateFlights.length :
                modal.title = l10nService.localize('Duplicate Error');
                modal.body = l10nService.localize(actionTripMessages.Booking.DuplicateFlights.part1) + l10nService.localize(actionTripMessages.Booking.DuplicateFlights.part2);
                modal.items = {
                    Flights: flightsDuplicationItems(duplicateFlights, tripDetails),
                };
                modal.flightDuplicateMessage = true;
                break;
            case !!duplicateHotels.length :
                modal.title = l10nService.localize('Duplicate Error');
                modal.body = l10nService.localize(actionTripMessages.Booking.DuplicateHotels.part1) + l10nService.localize(actionTripMessages.Booking.DuplicateHotels.part2);
                break;
            case !!(tripDetails.Status !== 'Held' && amadeusFlights.length) :
                modal.title = l10nService.localize('Book status');
                modal.body = _.template(l10nService.localize(actionTripMessages.Booking.IsSentForApproval.Failed))({id: tripId});
                modal.items = {
                    Flights: amadeusFlights,
                };
                modal.redirectTo = {
                    url: 'main.trip.details',
                    params: {id: tripId},
                };
                modal.amadeusFlightError = true;
                break;
        }

        if (toleranceHelper.needToAddToleranceMessage(response, bookingResponses, tripOptionsService)) {
            modal.body += ' ' + l10nService.localize(actionTripMessages.Booking.TolerancePassedButFailedItemsPresent);
        }
        modal.redirectTo = redirectTo;
        return modal;
    }

    function issuesChecker(bookingResponses, status) {
        return bookingResponses.length
            && bookingResponses.every((value) => !!value && value.BookingStatus === status);
    }

    function renderToleranceFail(response, tripId) {
        if (!response.IsToleranceEnabled) {
            return {
                redirectTo: flightStates.ROUNDTRIP,
                title: l10nService.localize('Technical issue'),
                body: l10nService.localize(actionTripMessages.Booking.AllFailed),
            };
        }

        toleranceHelper.saveAutoOpenBookSection(tripId);
        return {
            redirectTo: flightStates.ROUNDTRIP,
            title: l10nService.localize('Book status'),
            body: l10nService.localize(actionTripMessages.Booking.ToleranceFailed),
            reload: true,
        };
    }

    function isThereProblemWithPayment(response) {
        return response.PaymentStatus
            && response.PaymentStatus !== tripOptionsService.PAYMENT_STATUS.Successful;
    }

    function isBookingSucceeded(response) {
        return response.IsFullyBooked
            || response.IsSentForApproval
            || response.IsSentForConfirmation;
    }

    function flightsDuplicationChecker(bookingResponses) {
        return _.where(bookingResponses, {BookingStatus: tripOptionsService.BOOKING_STATUS.Duplicate,
            TripItemType: tripOptionsService.PRODUCT_TYPE.Flight});
    }

    function hotelsDuplicationChecker(bookingResponses) {
        return _.where(bookingResponses, {BookingStatus: tripOptionsService.BOOKING_STATUS.Duplicate,
            TripItemType: tripOptionsService.PRODUCT_TYPE.Hotel});
    }

    function flightsDuplicationItems(duplicateFlights, tripDetails) {
        const result = [];

        _.each(duplicateFlights, function(flight) {
            // TODO: get rid of magic numbers
            if (flight.ProductType === 1) {
                const element = _.findWhere(tripDetails.Flights, {Id: +flight.TripItemId});
                const flightDetails = {
                    element,
                    firstFlight: flightsUtils.firstLastFlight(element).first,
                    arrival: flightsUtils.firstLastFlight(element).last.ArrivalDate,
                    route: flightsUtils.collectAllCities(element.FlightGroups).join(' - '),
                };
                result.items.push(flightDetails);
            }
        });

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-booking/trip-booking-service.js